<template>
  <div class="flex items-center space-x-3 h-16 overflow-hidden">
    <!-- Logo -->

    <div class="h-full flex items-center mx-auto">
<!--      <a href="/" class="h-full flex items-center">-->
      <NuxtLink to="/" class="h-full flex items-center">
        <img
            src="/logo.png"
            alt="Logo"
            class="h-full w-auto max-h-full object-contain"
        /></NuxtLink>
<!--      </a>-->
    </div>
  </div>
</template>

<script setup>
const { t } = useI18n()
</script>
